import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function CTASection() {
  return <section id="price-section" className="py-12 px-4 sm:px-6 lg:px-8 bg-zinc-900 relative overflow-hidden" data-id="element-3">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#d4a574] rounded-full blur-[150px] opacity-5 pointer-events-none" data-id="element-4" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-5">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-6">
          <h2 className="text-2xl md:text-3xl font-serif text-white mb-2 leading-[1.05]" data-id="element-7">
            Si hoy estás cansado/a de intentar "hablar" y empeorar todo…
          </h2>
          <p className="text-base text-zinc-400 mb-6 font-light leading-[1.2]" data-id="element-8">
            Empieza con lo único que no humilla: <br data-id="element-9" />
            un mensaje corto, correcto, y con intención.
          </p>

          <div className="bg-[#0a0a0a] p-5 rounded-2xl border border-zinc-800 inline-block w-full max-w-md shadow-2xl" data-id="element-10">
            <h3 className="text-lg font-serif text-[#d4a574] mb-1 leading-[1.05]" data-id="element-11">
              Conexión Instantánea
            </h3>
            <p className="text-zinc-500 mb-4 text-xs leading-[1.2]" data-id="element-12">
              5 Mensajes que Reinician la Intimidad
            </p>

            <div className="flex items-baseline justify-center gap-2 mb-4" data-id="element-13">
              <span className="text-3xl font-bold text-white" data-id="element-14">$6.39</span>
            </div>

            <Button fullWidth icon href="https://narelaspace.com/cart/47533312278748:1" data-id="element-15">
              Quiero los 5 Mensajes
            </Button>

            <p className="mt-2 text-xs text-zinc-500 italic leading-[1.3]" data-id="element-16">
              Descarga inmediata • Acceso de por vida
            </p>

            <p className="mt-1 text-xs text-zinc-600 leading-[1.3]" data-id="element-17">
              Pago seguro y encriptado.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}